import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableViewFill = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M14.5 6H2.5V13C2.5 13.5523 2.94772 14 3.5 14L13.5 14C14.0523 14 14.5 13.5523 14.5 13V6Z"
          fill="white"
        />
        <path d="M14.5 2H2.5V6L14.5 6V2Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.49974 3.49993C1.49986 2.67157 2.17138 2 2.99982 2H9.99998H14.0002C14.8287 2 15.5003 2.67159 15.5002 3.50003L15.5 12.5C15.5 13.3284 14.8284 14 14 14H9.99998H2.99902C2.17121 14 1.49974 13.3293 1.49919 12.5013C1.49778 10.3677 1.49843 8.23397 1.49909 6.10051L1.49909 6.1005L1.49974 3.49993ZM5.5 3H9.49998V5.5L5.5 5.5V3ZM4.5 3H2.99982C2.72369 3 2.49978 3.22386 2.49974 3.50007L2.49924 5.5L2.5 5.5L4.5 5.5V3ZM4.5 6.5H2.5L2.49896 6.5C2.49866 7.50004 2.49839 8.50003 2.49836 9.5L2.5 9.5L4.5 9.5V6.5ZM4.5 10.5H2.5L2.49841 10.5C2.49851 11.1669 2.49875 11.8338 2.49919 12.5007C2.49937 12.7764 2.72303 13 2.99902 13H4.5V10.5ZM5.5 13V10.5L9.49998 10.5V13H5.5ZM5.5 9.5V6.5L9.49998 6.5V9.5L5.5 9.5ZM10.5 3V5.5L14.5 5.5H14.5002L14.5002 3.50001C14.5002 3.22386 14.2764 3 14.0002 3H10.5ZM10.5 6.5V9.5L14.5 9.5H14.5001L14.5002 6.5H14.5L10.5 6.5ZM10.5 10.5V13H14C14.2762 13 14.5 12.7761 14.5 12.5L14.5001 10.5H14.5L10.5 10.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default TableViewFill
